import {SDKEventAttrs} from '@mparticle/web-sdk';
import {RootState} from '../hooks/store';
import {selectChannelData} from '../store/slices/channel/slice';
import {countDaysFromCurrentDate} from './countDaysFromCurrentDate';

export type BrowseOtherSalonClickedTriggerContext =
  | 'availability/browse_other_salon'
  | 'availability/back_to_search'
  | 'availability/browse_more_results';
export const generateBrowseOtherSalonClickedAttributes = ({
  state,
  isMobile,
  triggerContext,
}: {
  state: RootState;
  isMobile: boolean;
  triggerContext: BrowseOtherSalonClickedTriggerContext;
}) => {
  const channel = selectChannelData(state);
  const eventAttributes: SDKEventAttrs = {
    country: channel.country.countryCode,
    platform: 'web',
    is_web_mobile: isMobile,
    trigger_context: triggerContext,
    days_from_current_date: countDaysFromCurrentDate(),
  };

  return eventAttributes;
};
